import React, { useState, useEffect, useRef, useCallback } from 'react';
import {
    AppLayout,
    Badge,
    Box,
    BreadcrumbGroup,
    Button,
    ColumnLayout,
    Container,
    Tabs,
    Grid,
    Header,
    HelpPanel,
    Icon,
    Modal,
    SpaceBetween,
    Spinner,
    Alert,
    Table,
    ExpandableSection,
    Flashbar,
    StatusIndicator,
    Link,
    Multiselect,
    TextContent,
    Pagination,
    FormField,
    Input,
    SegmentedControl,
    Select,
    ButtonDropdown,
    Textarea,
    Autosuggest,
    FileUpload,
    Checkbox
} from "@amzn/awsui-components-react";
import { Board, BoardItem } from "@amzn/awsui-board-components";
import { getQSDashboardEmbedLinksSync } from "../../../Ateam-BI/Templates/Utils/AppActivityUtils"
import { getBoardItems, getAllBoardItemsByOwner, updateBoardItem, updateLayout, getBooksWidgetContent, addBoardItem, deleteBoardItem } from "src/utilities/CloseAPIs"
import { configureGenericAppSync } from 'src/context/AuthContextUtility';
import { useSelector, useDispatch } from "react-redux";
import { selectIsEffectiveAdmin, selectIsEffectiveSupportAdmin } from 'src/utilities/adminUtils';
import { isMemberOf } from "src/checkPageAccess";
import { getEmbedableContentBasedOnType, cleanItemContent, getCleanedItemContent, validateURLByWebResource, safeParseStoredJSON } from "../CloseHelperMethods"
import ErrorComponent from "../../../Ateam-BI/Templates/components/ErrorComponent";
import { checkIfSupportAdmin, checkIfPortalAdmin } from 'src/checkPageAccess';
import {quicksightAccountMapper} from '../../../constants/AppConstants'
import { ACTION_METHODS, METRIC_TYPE, SITE_SERVICES } from 'src/katalMetrics/metricsModels';
import { tabTypes, STATIC_RESOURCES, ENV_SPECIFIC_RESOURCES, URL_RESOURCE_CONFIG, URL_RESOURCE_TYPES } from '../constants';
import { getRenderedLayout, getLayoutForSave, getLayoutForSaveAll } from '../boardLayoutUtils';
import useVisibleTimeTracker from 'src/katalMetrics/useVisibleTimeTracker';
import { useLocation } from 'react-router-dom';
import { createKatalTimerStopWatch, stopAndCaptureTimeMetricsWithBasicAttributes} from "src/katalMetrics/metricsHelperMethods"
import { TEMPLATE_APP, TEMPLATE_APP_PERMISSION, TEMPLATE_APP_TEAM, TEMPLATE_APP_OUTPUT, TEMPLATE_APP_ACCOUNTING, TEMPLATE_APP_USE_CASE, TEMPLATE_APP_SOURCE_DATA_TABLES, TEMPLATE_APP_CHART_OF_ACCOUNTS } from 'src/Ateam-BI/Templates/Constants';
import { API, graphqlOperation } from "aws-amplify";
import AppsCarouselComponent from './AppsCarouselComponent';
import DefaultCarouselComponent from './DefaultCarouselComponent';
import RichTextEditor from './CustomRichTextEditor';
import {uploadDocumentToVault} from "src/Ateam-BI/Vault/VaultAPIs"
import { VAULT_SERVICES } from 'src/Ateam-BI/Vault/constants';
import { v4 as uuidv4 } from 'uuid';
import { useHistory } from "react-router-dom";



function CPBoardView(props) {

    const [items, setItems] = useState([]);
    const [rawItems, setRawItems] = useState([]);
    const [showLoadingIcon, setShowLoadingIcon] = useState(true)
    const [selectedOwner, setSelectedOwner] = useState(props?.owner)
    const currentStage = useSelector((globalState) => globalState.auth.currentStage)
    const currentUser = useSelector((globalState) => globalState.auth.userId)
    const screenWidth = useSelector((globalState) => globalState.auth.screenWidth)
    const [viewAccess, setViewAccess] = useState(props.viewAccess)
    const [addOrEditAccess, setAddOrEditAccess] = useState(props.addOrEditAccess)
    const [file, setFile] = useState([])
    const history = useHistory();

    const [currentCarouselIndex, setCurrentCarouselIndex] = useState();
    const [currentUpdateItem, setCurrentUpdateItem] = useState({})
    const [visible, setVisible] = useState(false)
    const [addLineLabelInput, setAddLineLabelInput] = useState()
    const [addLineURLInput, setAddLineURLInput] = useState()
    const [updateLineURLInput, setUpdateLineURLInput] = useState()
    const [updateLineLabelInput, setUpdateLineLabelInput] = useState()
    const [errorText, setErrorText] = useState()
    const [selectedSegmentId, setSelectedSegmentId] = useState("add")
    const isPortalAdmin = useSelector(selectIsEffectiveAdmin)
    const isSupportAdmin = useSelector(selectIsEffectiveSupportAdmin)
    const [selectedUpdateOrDeleteItem, setSelectedUpdateOrDeleteItem] = useState()
    const [selectedResourceTypeToAdd, setSelectedResourceTypeToAdd] = useState()
    const [saveLayoutLoading, setSaveLayoutLoading] = useState(false)
    const [saveTextInputLoading, setSaveTextInputLoading] = useState(false)
    const [updateCarouselItemDescription, setUpdateCarouselItemDescription] = useState()
    const [updateCarouselItemTitle, setUpdateCarouselItemTitle] = useState()
    const [updateCurrentCarouselItem, setUpdateCurrentCarouselItem] = useState()
    const [carouselEditModalVisible, setCarouselEditModalVisible] = useState(false)
    const [selectedACApp, setSelectedACApp] = useState()
    const [bookStatusContent, setBookStatusContent] = useState()
    const [errorModalVisible, setErrorModalVisible] = useState(false)
    const [addResourceModalVisible, setAddResourceModalVisible] = useState(false)
    const [updateACAppsCarouselModalVisible, setUpdateACAppsCarouselModalVisible] = useState(false)
    const [newResourceTitle, setNewResourceTitle] = useState()
    const [selectedAppsToAdd, setSelectedAppsToAdd] = useState()
    const [apps, setApps] = useState()
    const [addItemQSURLInput, setAddItemQSURLInput] = useState()
    const [addItemDescriptionInput, setAddItemDescriptionInput] = useState()
    const [addItemLinkInput, setAddItemLinkInput] = useState()
    const [useSpecificUrlDetails, setUseSpecificUrlDetails] = useState(false)
    const [urlSegmentInput, setUrlSegmentInput] = useState('')
    const [addItemTextContent, setAddItemTextContent] = useState('')
    const [textInputDraft, setTextInputDraft] = useState('')
    const [textInputTitleDraft, setTextInputTitleDraft] = useState('')
    const [textInputModalVisible, setTextInputModalVisible] = useState(false)
    const [textInputEditItem, setTextInputEditItem] = useState(null)
    const [searchValue, setSearchValue] = useState("")
    const [searchItems, setSearchItems] = useState([])
    const [fetchingSearchItems, setFetchingSearchItems] = useState(true)
    const ln = useLocation()
    useVisibleTimeTracker([{
            metricName : 'actionPerformedBy',
            metricValue : currentUser,
            metricType : METRIC_TYPE.STRING,
            isMonitor : true
        },
        {
            metricName : 'pagePath',
            metricValue : `${ln.pathname}`,
            metricType : METRIC_TYPE.STRING,
            isMonitor : true
        }
        ], "timeSpent", ACTION_METHODS.TIME_SPENT_ON_PAGE, SITE_SERVICES.CLOSE_PORTAL);
    
    useEffect(() => {
        loadData()
    }, [selectedOwner, currentStage, currentUser, screenWidth])

    useEffect(() => {
        
         return () => {
      // Perform cleanup here, e.g., clear timers or unsubscribe from events
    };
    }, [])

    useEffect(() => {
        setSelectedOwner(props?.owner)
    }, [props?.owner])

    useEffect(()=>{
        setViewAccess(props.viewAccess)
    },[props.viewAccess])

    useEffect(()=>{
        setAddOrEditAccess(props.addOrEditAccess)
    },[props.addOrEditAccess])


    useEffect(() => {
        setItems(items)
    }, [currentCarouselIndex])
    

    useEffect(() => {
        if (selectedUpdateOrDeleteItem) {
            setUpdateLineURLInput(selectedUpdateOrDeleteItem?.value)
            setUpdateLineLabelInput(selectedUpdateOrDeleteItem?.label)
        }
    }, [selectedUpdateOrDeleteItem])

        useEffect(()=> {
            setAddLineLabelInput()
            setAddLineURLInput()
            setUpdateLineURLInput()
            setUpdateLineLabelInput()
            setSelectedUpdateOrDeleteItem()
        },[selectedSegmentId])

    
        useEffect(() => {
            if(addOrEditAccess === true) {
                setItems(prevItems =>
        prevItems.map(item => {
            // Only rebuild carousel components
            if (
                item?.contentType === "ACCOUNTING-CENTRAL-APPS-CAROUSEL" 
            ) {
                const jsonContent = item.rawContent;
                const itemData = item.rawItem;

                const newContent =
                    (
                        <AppsCarouselComponent
                            jsonContent={jsonContent}
                            item={itemData}
                            onModifyClick={onModifyClick}
                            addOrEditAccess={addOrEditAccess}
                        />
                    ) 

                return {
                    ...item,
                    data: {
                        ...item.data,
                        content: newContent
                    }
                };
            }

            return item; // leave other items untouched
        })
    );
            }
    
}, [addOrEditAccess]);


    const loadData = async () => {
        const pageLoadTime = createKatalTimerStopWatch("timeTaken")
        try {
        // Get Drop downs
        // Load Initial Data
        setShowLoadingIcon(true)
            await Promise.all([
        new Promise((resolve, reject) => {
            getBoardItems(props?.pageType, props?.owner?.value, tabTypes.BOARD, function onSuccess(result) {
            let data = result.data.getBoardItemsRDS
            data = JSON.parse(data)
            setRawItems(data)
            const boardItems = data?.map((item, index) => {

                const boardItem = {}
                const layout = getRenderedLayout(item, screenWidth)
                boardItem["columnOffset"] = layout.columnOffset
                const jsonContent = JSON.parse(item?.board_item_content?.replaceAll("'", '"'))
                boardItem["id"] = item?.board_item_id
                boardItem["rowSpan"] = layout.rowSpan
                boardItem["columnSpan"] = layout.columnSpan
                boardItem["contentType"] = item?.board_item_content_type
                boardItem["rawContent"] = jsonContent
                boardItem["rawItem"] = item
                const data = {}
                data["title"] = item?.board_item_title
                if (item?.board_item_content_type === 'WIDGET' && jsonContent?.type === 'BOOKS-STATUS') {
                    data["content"] = (<Box>
                                        <Spinner></Spinner>
                                        Loading...
                                    </Box>)
                     getBooksWidgetContent(function onSuccess(result) {
                        const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                        const d = new Date();
                        let month = months[d.getMonth()];
                        let year = d.getFullYear();
                        const res = result.data.getBooksStatusRDS
                        const booksStatus = JSON.parse(res)?.[0]
                        setBookStatusContent(booksStatus)
                        configureGenericAppSync()
                        data["content"] =  (<>
                        <Box>

                            <TextContent>
                                <SpaceBetween size="xxl">
                                    <><h2><Icon name={booksStatus?.opex_open ? "status-positive" : "status-negative"} variant={booksStatus?.opex_open ? "success" : "error"} /> OPEX is <span style={booksStatus?.opex_open ? { color: "#00802f" } : { color: "#db0000" }}>{booksStatus?.opex_open ? 'OPEN' : 'CLOSED'}</span> for {`${month} ${year}`}</h2></>
                                    <><h2><Icon name={booksStatus?.operating_income_open ? "status-positive" : "status-negative"} variant={booksStatus?.operating_income_open ? "success" : "error"} /> OPERATING INCOME is <span style={booksStatus?.operating_income_open ? { color: "#00802f" } : { color: "#db0000" }}>{booksStatus?.operating_income_open ? 'OPEN' : 'CLOSED'}</span> for {`${month} ${year}`}</h2></>
                                    <><h2><Icon name={booksStatus?.whiteboard_open ? "status-positive" : "status-negative"} variant={booksStatus?.whiteboard_open ? "success" : "error"} /> WHITEBOARD is <span style={booksStatus?.whiteboard_open ? { color: "#00802f" } : { color: "#db0000" }}>{booksStatus?.whiteboard_open ? 'OPEN' : 'CLOSED'}</span></h2></>
                                </SpaceBetween>
                            </TextContent>

                        </Box>
                        </>)
                        //  setShowLoadingIcon(false)
                    }, function onFailure(response) {
                        configureGenericAppSync()
                        data["content"] = (<>
                        <Box>

                            <TextContent>
                                <SpaceBetween size="xxl">
                                    <><h2><Icon name="status-negative" variant="error" /> Unable to fetch Books status</h2></>
                                </SpaceBetween>
                            </TextContent>

                        </Box>
                        </>)
                    })
                } else if(item?.board_item_content_type === 'ACCOUNTING-CENTRAL-APPS-CAROUSEL') {
                    data["content"] = <AppsCarouselComponent jsonContent={jsonContent} item = {item} onModifyClick = {onModifyClick} addOrEditAccess={addOrEditAccess === true ? true : false}/>
                } else if(item?.board_item_content_type === 'CAROUSEL') {
                    data["content"] = <DefaultCarouselComponent jsonContent={jsonContent} item = {item} onOpenDashboardClick = {onOpenDashboardClick} updateCarouselIndex = {updateCarouselIndex} />
                } else {
                getEmbedableContentBasedOnType(jsonContent, item?.board_item_content_type, props?.tabType, {"owner_id": selectedOwner.value}).then((result) => {
                    data["content"] = result
                    boardItem["data"] = data
                    setItems(prev => prev.map(i => i.id === boardItem.id ? { ...i, data: { ...i.data, content: result } } : i))
                })
                }
                boardItem["data"] = data
                return boardItem

            })

            setItems(boardItems)
            setShowLoadingIcon(false)
            configureGenericAppSync()
            resolve();
        }, function onFailure(response) {
            configureGenericAppSync()
            setShowLoadingIcon(false)
            reject();
        })
        })])
        
    } finally {
        if(!pageLoadTime.isStopped) {
            stopAndCaptureTimeMetricsWithBasicAttributes(pageLoadTime, currentUser, `${ln.pathname}${location.search}`,ACTION_METHODS.PAGE_LOAD_TIME , SITE_SERVICES.CLOSE_PORTAL)
        }
    }
    
    }

    const getAllBoardItemsByOwnerTrigger = async () => {
        setFetchingSearchItems(true)
        const res = await getAllBoardItemsByOwner(props?.owner?.value, function onSuccess(result) {
            let data = result.data.getAllBoardItemsByOwnerRDS
            data = JSON.parse(data)
            setSearchItems(data?.map((item) => {
                return { ...item, label: item?.board_item_title, value: item?.board_item_title, description: item?.board_item_content_type }
            }))
            configureGenericAppSync()
            setFetchingSearchItems(false)
        }, function onFailure(response) {
            configureGenericAppSync()
            setFetchingSearchItems(false)
        })
    }

    const addNewTracker = async () => {
        let links = currentUpdateItem?.content?.links
        if (!links) {
            links = []
        }
        const foundLabel = links.find((link) => link.label === addLineLabelInput)
        if (foundLabel) {
            setErrorText('Document / Tracker with same label already exists!')
            return
        }

        const foundURL = links.find((link) => link.value === addLineURLInput)
        if (foundURL) {
            setErrorText('Document / Tracker with same URL already exists!')
            return
        }

        if (currentUpdateItem.hasOwnProperty('id') && currentUpdateItem.hasOwnProperty('title'), currentUpdateItem.hasOwnProperty('content') && addLineLabelInput && addLineURLInput) {
            if(!addLineURLInput?.startsWith('https://')) {
                setErrorText('Not a Valid URL!')
                return;
            }
            setShowLoadingIcon(true)
            links.push({ "label": addLineLabelInput, "value": addLineURLInput })
            let linksInput = { "links": links }
            linksInput = JSON.stringify(linksInput)
            linksInput = linksInput.replaceAll('"', "'")
            const input = { "board_item_id": currentUpdateItem?.id, "board_item_title": currentUpdateItem?.title, "board_item_content": linksInput, "last_updated_by": currentUser }
            await updateBoardItem(input, function onSuccess(result) {
                setVisible(false)
                setAddLineLabelInput()
                setAddLineURLInput()
                setUpdateLineURLInput()
                setUpdateLineLabelInput()
                setCurrentUpdateItem({})
                setSelectedUpdateOrDeleteItem({})
                setSelectedSegmentId('add')
                setErrorText()
                loadData()
                configureGenericAppSync()
            }, function onFailure(response) {
                setVisible(false)
                setAddLineLabelInput()
                setAddLineURLInput()
                setUpdateLineURLInput()
                setUpdateLineLabelInput()
                setCurrentUpdateItem({})
                setSelectedUpdateOrDeleteItem({})
                setSelectedSegmentId('add')
                configureGenericAppSync()
                setShowLoadingIcon(false)
            })
        } else {
            setErrorText('All fields are required!')
        }
    }

    const updateTracker = async () => {


        let links = currentUpdateItem?.content?.links
        if (!links) {
            links = []
        }
        const foundIndex = selectedUpdateOrDeleteItem?.index
        if (foundIndex === -1) {
            setErrorText('Document not found')
            return
        }
        if (currentUpdateItem.hasOwnProperty('id') && currentUpdateItem.hasOwnProperty('title'), currentUpdateItem.hasOwnProperty('content') && selectedUpdateOrDeleteItem && updateLineURLInput && updateLineLabelInput) {
            setShowLoadingIcon(true)
            links.splice(foundIndex, 1, { "label": updateLineLabelInput, "value": updateLineURLInput })
            let linksInput = { "links": links }
            linksInput = JSON.stringify(linksInput)
            linksInput = linksInput.replaceAll('"', "'")
            const input = { "board_item_id": currentUpdateItem?.id, "board_item_title": currentUpdateItem?.title, "board_item_content": linksInput, "last_updated_by": currentUser }
            await updateBoardItem(input, function onSuccess(result) {
                setVisible(false)
                setAddLineLabelInput()
                setAddLineURLInput()
                setCurrentUpdateItem({})
                setUpdateLineURLInput()
                setUpdateLineLabelInput()
                setErrorText()
                setSelectedSegmentId('add')
                setSelectedUpdateOrDeleteItem()
                loadData()
                configureGenericAppSync()
            }, function onFailure(response) {
                setVisible(false)
                setAddLineLabelInput()
                setAddLineURLInput()
                setUpdateLineURLInput()
                setUpdateLineLabelInput()
                setCurrentUpdateItem({})
                setSelectedUpdateOrDeleteItem()
                setSelectedSegmentId('add')
                configureGenericAppSync()
                setShowLoadingIcon(false)
            })
        } else {
            setErrorText('All fields are required!')
        }

    }

    const updateAccountingCentralCarousel = async () => {

        
        if (currentUpdateItem.hasOwnProperty('id') && currentUpdateItem.hasOwnProperty('title'), currentUpdateItem.hasOwnProperty('content') && selectedAppsToAdd) {
            setShowLoadingIcon(true)
            let content = {}
            content["items"] = selectedAppsToAdd?.map((app) => {
                    const description = cleanItemContent(app?.app_description ? app?.app_description : '')
                    return {
                        title: app?.label,
                        description: description,
                        link: app?.customURL ?  app?.customURL : `/App/${app?.value}`,
                        id: app?.value,
                        customURL: app?.customURL ? app?.customURL : ''
                    }
                })
            content = JSON.stringify(content)
            content = content.replaceAll('"', "'")
            const input = { "board_item_id": currentUpdateItem?.id, "board_item_title": currentUpdateItem?.title, "board_item_content": content, "last_updated_by": currentUser }
            await updateBoardItem(input, function onSuccess(result) {
                setErrorText()
                setCurrentUpdateItem()
                setSelectedAppsToAdd()
                setUpdateACAppsCarouselModalVisible(false)
                loadData()
                configureGenericAppSync()
            }, function onFailure(response) {
                setErrorText()
                setCurrentUpdateItem()
                setSelectedAppsToAdd()
                setUpdateACAppsCarouselModalVisible(false)
                configureGenericAppSync()
                setShowLoadingIcon(false)
            })
        } else {
            setErrorText('All fields are required!')
        }

    }

    const deleteTracker = async () => {
        let links = currentUpdateItem?.content?.links
        if (!links) {
            links = []
        }
        const foundIndex = selectedUpdateOrDeleteItem?.index
        if (foundIndex === -1) {
            setErrorText('Document not found')
            return
        }
        if (currentUpdateItem.hasOwnProperty('id') && currentUpdateItem.hasOwnProperty('title'), currentUpdateItem.hasOwnProperty('content') && selectedUpdateOrDeleteItem) {
            setShowLoadingIcon(true)
            links.splice(foundIndex, 1)
            let linksInput = { "links": links }
            linksInput = JSON.stringify(linksInput)
            linksInput = linksInput.replaceAll('"', "'")
            const input = { "board_item_id": currentUpdateItem?.id, "board_item_title": currentUpdateItem?.title, "board_item_content": linksInput, "last_updated_by": currentUser }
            await updateBoardItem(input, function onSuccess(result) {
                setVisible(false)
                setAddLineLabelInput()
                setAddLineURLInput()
                setCurrentUpdateItem({})
                setUpdateLineURLInput()
                setUpdateLineLabelInput()
                setErrorText()
                setSelectedUpdateOrDeleteItem()
                setSelectedSegmentId('add')
                loadData()
                configureGenericAppSync()
            }, function onFailure(response) {
                setVisible(false)
                setAddLineLabelInput()
                setAddLineURLInput()
                setUpdateLineURLInput()
                setUpdateLineLabelInput()
                setCurrentUpdateItem({})
                setSelectedUpdateOrDeleteItem()
                configureGenericAppSync()
                setSelectedSegmentId('add')
                setShowLoadingIcon(false)
            })
        }
    }

    const saveTextInput = async () => {
        if (!textInputEditItem) return;
        if (!textInputTitleDraft?.trim()) {
            setErrorText('Title cannot be empty');
            return;
        }
        setSaveTextInputLoading(true)
        setShowLoadingIcon(true)
        let content = { text: cleanItemContent(textInputDraft) }
        let contentStr = JSON.stringify(content).replaceAll('"', "'")
        const input = { "board_item_id": textInputEditItem?.id, "board_item_title": textInputTitleDraft, "board_item_content": contentStr, "last_updated_by": currentUser }
        await updateBoardItem(input, function onSuccess(result) {
            setTextInputModalVisible(false)
            setTextInputDraft('')
            setTextInputTitleDraft('')
            setTextInputEditItem(null)
            setErrorText()
            setSaveTextInputLoading(false)
            loadData()
            configureGenericAppSync()
        }, function onFailure(response) {
            setErrorText('Failed to save. Please try again.')
            setSaveTextInputLoading(false)
            setShowLoadingIcon(false)
            configureGenericAppSync()
        })
    }

    const saveLayout = async () => {
        setSaveLayoutLoading(true)
        const itemsInput = getLayoutForSaveAll(items, screenWidth)

        await updateLayout(itemsInput , function onSuccess(result) {
            configureGenericAppSync()
            setSaveLayoutLoading(false)
        }, function onFailure(response) {
            configureGenericAppSync()
            setSaveLayoutLoading(false)
        })

    }

    const removeItemOnCarousel = async () => {
        let carouselItem = items.find((item)=> item?.contentType === 'CAROUSEL')
        let currentCarouselItems = carouselItem?.rawContent?.items
        let title = carouselItem?.data?.title
        if(currentCarouselItems) {
            currentCarouselItems.splice(currentCarouselIndex - 1, 1)
            const items = {items : currentCarouselItems}
            let content = JSON.stringify(items)
            content = content.replaceAll('"', "'")
            const input = { "board_item_id": carouselItem?.id, "board_item_title": title, "board_item_content": content, "last_updated_by": currentUser }
                await updateBoardItem(input, function onSuccess(result) {
                    setErrorText()
                    setCurrentCarouselIndex(1)
                    loadData()
                    configureGenericAppSync()
                }, function onFailure(response) {
                    setShowLoadingIcon(false)
                    configureGenericAppSync()
                })
        }
    }

    const editItemOnCarousel = () => {
    let carouselItem = items.find((item)=> item?.contentType === 'CAROUSEL')
    let currentCarouselItems = carouselItem?.rawContent?.items
    let dashboard = currentCarouselItems[currentCarouselIndex - 1]
    let title = dashboard?.title
    let description = getCleanedItemContent(dashboard?.description)
    setUpdateCarouselItemTitle(title)
    setUpdateCarouselItemDescription(description)
    setUpdateCurrentCarouselItem(carouselItem)
    setCarouselEditModalVisible(true)
}

const updateCarouselonSave = async () => {
    if(!updateCarouselItemTitle || !updateCarouselItemDescription || !updateCurrentCarouselItem) {
        setErrorText('All fields are required!')
        return
    }    
    setShowLoadingIcon(true)
    let currentCarouselItems = updateCurrentCarouselItem?.rawContent?.items
    let newItem = currentCarouselItems[currentCarouselIndex - 1]
    newItem.title = updateCarouselItemTitle
    newItem.description = cleanItemContent(updateCarouselItemDescription)
    currentCarouselItems.splice(currentCarouselIndex - 1, 1, newItem)
    const items = {items : currentCarouselItems}
    let content = JSON.stringify(items)
    content = content.replaceAll('"', "'")
    const input = { "board_item_id": updateCurrentCarouselItem?.id, "board_item_title": updateCurrentCarouselItem?.data?.title, "board_item_content": content, "last_updated_by": currentUser }
        await updateBoardItem(input, function onSuccess(result) {
            setErrorText()
            setCurrentCarouselIndex(1)
            setCarouselEditModalVisible(false)
            setUpdateCarouselItemTitle()
            setUpdateCarouselItemDescription()
            setUpdateCurrentCarouselItem()
            loadData()
            configureGenericAppSync()
        }, function onFailure(response) {
            setShowLoadingIcon(false)
            setCarouselEditModalVisible(false)
            setUpdateCarouselItemTitle()
            setUpdateCarouselItemDescription()
            setUpdateCurrentCarouselItem()
            configureGenericAppSync()
        })
}

const addItem = async () => {
    if(selectedResourceTypeToAdd && newResourceTitle) {
        if(selectedResourceTypeToAdd?.value === 'KEY-VALUE-LINKS' ||
           selectedResourceTypeToAdd?.value === 'TEXT' ||
           (selectedResourceTypeToAdd?.value === 'ACCOUNTING-CENTRAL-APPS-CAROUSEL' && selectedAppsToAdd) || 
           selectedResourceTypeToAdd?.value === 'CUSTOM-DASHBOARDS-CAROUSEL' ||
           (selectedResourceTypeToAdd?.value === 'PDF' && file?.length > 0)) {
            setShowLoadingIcon(true)
            let content = {}
            const fileId = uuidv4();
            if (selectedResourceTypeToAdd?.value === 'KEY-VALUE-LINKS') {
                content["links"] = []
            } else if (selectedResourceTypeToAdd?.value === 'TEXT') {
                content["text"] = cleanItemContent(addItemTextContent || '')
            } else if (selectedResourceTypeToAdd?.value === 'ACCOUNTING-CENTRAL-APPS-CAROUSEL') {
                content["items"] = selectedAppsToAdd?.map((app) => {
                        const description = cleanItemContent(app?.app_description ? app?.app_description : '')
                    return {
                        title: app?.label,
                        description: description,
                        link: app?.customURL ?  app?.customURL : `/App/${app?.value}`,
                        id: app?.value,
                        customURL: app?.customURL ? app?.customURL : ''
                    }
                })
            } else if (selectedResourceTypeToAdd?.value === 'CUSTOM-DASHBOARDS-CAROUSEL') {
                content["items"] = []
            } else if (selectedResourceTypeToAdd?.value === 'PDF') {
                content["file_id"] =   fileId          
            }
            content = JSON.stringify(content)
            content = content.replaceAll('"', "'")
            const isDefault = selectedOwner?.owner_type === "DEFAULT"
            // New format: store spans for both grid sizes in column_offset._spans
            // Small items (links, text): 1 col on 4-col grid, 2 cols on 6-col grid
            // Larger items (carousels, etc.): 2 cols on 4-col grid, 3 cols on 6-col grid
            const isSmallItem = (selectedResourceTypeToAdd?.value === 'KEY-VALUE-LINKS' || selectedResourceTypeToAdd?.value === 'TEXT')
            const itemColumnSpan = isSmallItem ? "1" : "2"
            let columnOffset = { "4": 0, "6": 0, "_spans": { "4": isSmallItem ? 1 : 2, "6": isSmallItem ? 2 : 3 } }
            columnOffset = JSON.stringify(columnOffset).replaceAll('"', "'")
            const input = {
                "board_item_title": newResourceTitle,
                "board_item_content": content,
                "board_item_content_type": selectedResourceTypeToAdd?.value,
                "owner_id": selectedOwner?.value,
                "is_default": isDefault,
                "board_page_type": props?.pageType,
                "created_by": currentUser,
                "last_updated_by": currentUser,
                "row_span": "3",
                "column_span": itemColumnSpan,
                "column_offset": columnOffset,
                "row_order": items?.length + 1,
                "section": props?.pageType
            }
            if(selectedResourceTypeToAdd?.value === "PDF") {
                await uploadDocumentToVault("pdf", VAULT_SERVICES.CLOSE_PORTAL, {"file_id": fileId, "owner_id": selectedOwner?.value}, file[0])
            }
            await addBoardItem(input, function onSuccess(result) {
                setAddResourceModalVisible(false)
                setSelectedResourceTypeToAdd()
                setNewResourceTitle()
                setAddItemTextContent('')
                setFile([])
                setErrorText()
                loadData()
                configureGenericAppSync()
            }, function onFailure(response) {
                setAddResourceModalVisible(false)
                setFile([])
                setErrorText()
                setAddItemTextContent('')
                setSelectedResourceTypeToAdd()
                setNewResourceTitle()
                configureGenericAppSync()
                setShowLoadingIcon(false)
            })
            
        } else if (((selectedResourceTypeToAdd?.value === 'WIKI' ||
                    selectedResourceTypeToAdd?.value === 'BROADCAST' ||
                    selectedResourceTypeToAdd?.value === 'BOOKS-STATUS' ||
                    selectedResourceTypeToAdd?.value === 'STARMAP' ||
                    URL_RESOURCE_TYPES.includes(selectedResourceTypeToAdd?.value) ||
                    selectedResourceTypeToAdd?.value === 'ACR' ||
                    selectedResourceTypeToAdd?.value === 'WEBPAGE') && addItemLinkInput ) || 
                    ((selectedResourceTypeToAdd?.value === 'QUICKSIGHT' || selectedResourceTypeToAdd?.value === 'AMAZON-BI-QS') && addItemQSURLInput  && addItemDescriptionInput) ||
                    selectedResourceTypeToAdd?.value === 'BOOKS-STATUS' ||
                    (selectedResourceTypeToAdd?.value === 'ACCOUNTING-CENTRAL-APP' && selectedACApp) ||
                    Object.keys(STATIC_RESOURCES).includes(selectedResourceTypeToAdd?.value) ||
                    Object.keys(ENV_SPECIFIC_RESOURCES).includes(selectedResourceTypeToAdd?.value)) {

                  
                if (selectedResourceTypeToAdd?.value === 'BOOKS-STATUS' || 
                    selectedResourceTypeToAdd?.value === 'ACCOUNTING-CENTRAL-APP' ||
                    Object.keys(STATIC_RESOURCES).includes(selectedResourceTypeToAdd?.value) || 
                    Object.keys(ENV_SPECIFIC_RESOURCES).includes(selectedResourceTypeToAdd?.value) ||
                    validateURLByWebResource((selectedResourceTypeToAdd?.value === 'QUICKSIGHT' || selectedResourceTypeToAdd?.value === 'AMAZON-BI-QS') ?
                    addItemQSURLInput : addItemLinkInput, selectedResourceTypeToAdd?.value)) {
                    
                setShowLoadingIcon(true)
                let content = {}
                content["url"] = (selectedResourceTypeToAdd?.value === 'QUICKSIGHT' || selectedResourceTypeToAdd?.value === 'AMAZON-BI-QS') ? addItemQSURLInput : addItemLinkInput
                if (selectedResourceTypeToAdd?.value === 'QUICKSIGHT' || selectedResourceTypeToAdd?.value === 'AMAZON-BI-QS') {
                    content["description"] = cleanItemContent(addItemDescriptionInput)
                }
                if (selectedResourceTypeToAdd?.value === 'BOOKS-STATUS') {
                    content = {}
                    content["type"] = "BOOKS-STATUS"
                }
                if(Object.keys(STATIC_RESOURCES).includes(selectedResourceTypeToAdd?.value)) {
                    content = {}
                    content["url"] = STATIC_RESOURCES[selectedResourceTypeToAdd?.value]
                }
                if(Object.keys(ENV_SPECIFIC_RESOURCES).includes(selectedResourceTypeToAdd?.value)) {
                    content = {}
                    content["url"] = ENV_SPECIFIC_RESOURCES[selectedResourceTypeToAdd?.value][currentStage]
                }
                if(selectedResourceTypeToAdd?.value === 'ACCOUNTING-CENTRAL-APP') {
                content = {}
                let stage = currentStage === 'prod' ? '' : 'beta.'
                let url;
                if(selectedACApp?.customURL && selectedACApp?.customURL?.trim() !== '') {
                    url = `https://${stage}bi-central.accounting.amazon.dev${selectedACApp?.customURL}`
                } else {
                    url = `https://${stage}bi-central.accounting.amazon.dev/App/${selectedACApp?.value}`
                }
                content["url"] = url
                }
                content = JSON.stringify(content)
                content = content.replaceAll('"', "'")
                const isDefault = selectedOwner?.owner_type === "DEFAULT"
                // New format: 1 col on 4-col grid, 2 cols on 6-col grid
                let columnOffset = { "4": 0, "6": 0, "_spans": { "4": 1, "6": 2 } }
                columnOffset = JSON.stringify(columnOffset).replaceAll('"', "'")
                const input = {
                    "board_item_title": newResourceTitle,
                    "board_item_content": content,
                    "board_item_content_type": selectedResourceTypeToAdd?.value === 'QUICKSIGHT' ? 'QUICKSIGHT' : selectedResourceTypeToAdd?.value === 'BOOKS-STATUS' ? 'WIDGET' : 'WEBPAGE',
                    "owner_id": selectedOwner?.value,
                    "is_default": isDefault,
                    "board_page_type": props?.pageType,
                    "created_by": currentUser,
                    "last_updated_by": currentUser,
                    "row_span": "2",
                    "column_span": "1",
                    "column_offset": columnOffset,
                    "row_order": items?.length + 1,
                    "section": props?.pageType
                }
                await addBoardItem(input, function onSuccess(result) {
                    setAddResourceModalVisible(false)
                    setSelectedResourceTypeToAdd()
                    setNewResourceTitle()
                    setAddItemQSURLInput()
                    setAddItemLinkInput()
                    setAddItemDescriptionInput()
                    setErrorText()
                    setUseSpecificUrlDetails(false)
                    setUrlSegmentInput('')
                    loadData()
                    configureGenericAppSync()

                }, function onFailure(response) {
                    setAddResourceModalVisible(false)
                    setSelectedResourceTypeToAdd()
                    setNewResourceTitle()
                    setAddItemQSURLInput()
                    setAddItemLinkInput()
                    setAddItemDescriptionInput()
                    setErrorText()
                    setUseSpecificUrlDetails(false)
                    setUrlSegmentInput('')
                    configureGenericAppSync()
                    setShowLoadingIcon(false)
                })

                } else {
                    setErrorText('Please provide a valid URL with respect to resource')
                }
            
            }  
        
        else {
            setErrorText('All fields are required!')
        }
    } else {
        setErrorText('All fields are required!')
    }

}

    const queryApps = async () => {

        let mQry = `
                query MyQuery {
                  getAppsV2  {
                      ${TEMPLATE_APP.APP_NAME}
                      ${TEMPLATE_APP.APP_DESCRIPTION}
                      ${TEMPLATE_APP.APP_ID}
                      ${TEMPLATE_APP.URL}
                  }
                }  
                    `;
                let response = await API.graphql(graphqlOperation(mQry));
                let qResultJSON = response.data.getAppsV2;
                setApps(qResultJSON)
    }

    const deleteItem = async (id) => {
            if (id) {
                setShowLoadingIcon(true)
                await deleteBoardItem(id, function onSuccess(result) {
                    loadData()
                    setErrorText()
                }, function onFailure(response) {
                    setShowLoadingIcon(false)
                })
            } else {
                setErrorText('Select resource to remove')
            }
    
        }

    const onModifyClick = (item, jsonContent) => {
            queryApps()
            const updateItem = {}
            updateItem["id"] = item?.board_item_id
            updateItem["title"] = item?.board_item_title
            updateItem["content"] = item
            setCurrentUpdateItem(updateItem)
            setSelectedAppsToAdd(jsonContent?.items?.map((i)=>({"label": i?.title, "value": i?.id, "customURL": i?.customURL, "app_description": i?.description})))
            setUpdateACAppsCarouselModalVisible(true)
    }

    const onOpenDashboardClick = (jsonContent, index) => {
        const exists = props?.openResource(jsonContent?.items[index - 1]?.page_type, jsonContent?.items[index - 1]?.id)
        if(!exists) {
            setErrorModalVisible(true)
        } else {
            history.push(`/ClosePortal/${jsonContent?.items[index - 1]?.page_type?.replaceAll('/', '%2F')}/Page/${selectedOwner?.value}?${jsonContent?.items[index - 1]?.id}`)
        }
    }

    const updateCarouselIndex = (index) => {
        setCurrentCarouselIndex(index)
    }

    return (
        <>
            {showLoadingIcon === true ? <Box margin="xxl" padding="xxl" textAlign="center">
                <Spinner size="large" />
            </Box> : (showLoadingIcon === false && typeof (viewAccess) === 'boolean' && viewAccess === false) ? <>
                <ErrorComponent header="Access Denied" message={`User is not authorized to view this page.`} />
            </> :
                <Box>
                    <Modal
                        onDismiss={() => {
                            setAddLineLabelInput()
                            setAddLineURLInput()
                            setCurrentUpdateItem({})
                            setUpdateLineURLInput()
                            setUpdateLineLabelInput()
                            setSelectedUpdateOrDeleteItem()
                            setErrorText()
                            setSelectedSegmentId('add')
                            setVisible(false)
                        }}
                        visible={visible}
                        footer={
                            <>
                                {errorText && (<span style={{ color: "#db0000" }}>{errorText}</span>)}
                                <Box float="right">
                                    <SpaceBetween direction="horizontal" size="xs">
                                        <Button variant="link" onClick={
                                            () => {
                                                setAddLineLabelInput()
                                                setAddLineURLInput()
                                                setCurrentUpdateItem({})
                                                setUpdateLineURLInput()
                                                setUpdateLineLabelInput()
                                                setSelectedUpdateOrDeleteItem()
                                                setErrorText()
                                                setSelectedSegmentId('add')
                                                setVisible(false)
                                            }
                                        }>Cancel</Button>
                                        {selectedSegmentId === 'add' && (
                                            <Button variant="primary" onClick={addNewTracker}>Add line</Button>
                                        )}
                                        {selectedSegmentId === 'update' && (
                                            <Button variant="primary" onClick={updateTracker}>Update line</Button>
                                        )}
                                        {selectedSegmentId === 'delete' && (
                                            <Button variant="primary" onClick={deleteTracker}>Remove line</Button>
                                        )}

                                    </SpaceBetween>
                                </Box>
                            </>
                        }
                        header="Modify key documents and trackers"
                    >
                        <div style={{ display: "flex", justifyContent: "center" }}>
                            <SegmentedControl
                                selectedId={selectedSegmentId}
                                onChange={({ detail }) =>
                                    setSelectedSegmentId(detail.selectedId)
                                }
                                label="Modify Trackers"
                                options={[
                                    { text: "Add", id: "add", iconName: "add-plus" },
                                    { text: "Update", id: "update", iconName: "edit" },
                                    { text: "Remove", id: "delete", iconName: "remove" }
                                ]}
                            />
                        </div>
                        {selectedSegmentId === "add" && (
                            <>
                                <h3>
                                    <span style={{ color: "#006ce0" }}>Add new</span>
                                </h3>

                                <FormField
                                    label="Displayed name"
                                >
                                    <Input onChange={({ detail }) => setAddLineLabelInput(detail.value)}
                                        value={addLineLabelInput}
                                        placeholder='Provide a display name'
                                    />
                                </FormField>
                                <FormField
                                    label="URL"
                                >
                                    <Input onChange={({ detail }) => setAddLineURLInput(detail.value)}
                                        value={addLineURLInput}
                                        placeholder='Provide full URL, including https://' />
                                </FormField>
                            </>
                        )}

                        {selectedSegmentId === 'update' && (
                            <>
                                <h3>
                                    <span style={{ color: "#006ce0" }}>Update existing</span>
                                </h3>
                                <FormField
                                    label="Document to update"
                                >
                                    <Select
                                        selectedOption={selectedUpdateOrDeleteItem}
                                        onChange={({ detail }) => {
                                            setSelectedUpdateOrDeleteItem(detail.selectedOption)
                                        }
                                        }
                                        options={currentUpdateItem?.content?.links?.map((i, index) => ({...i, 'index': index}))}
                                        placeholder='Select document or tracker to update'
                                    />
                                </FormField>
                                {selectedUpdateOrDeleteItem && (
                                    <>
                                    <FormField
                                    label="Displayed Name"
                                >
                                    <Input onChange={({ detail }) => setUpdateLineLabelInput(detail.value)}
                                        value={updateLineLabelInput}
                                        placeholder='Provide a display name' />
                                </FormField>

                                <FormField
                                    label="URL"
                                >
                                    <Input onChange={({ detail }) => setUpdateLineURLInput(detail.value)}
                                        value={updateLineURLInput}
                                        placeholder='Provide full URL, including https://' />
                                </FormField>
                                </>
                                )}
                                
                            </>
                        )}


                        {selectedSegmentId === 'delete' && (
                            <>
                                <h3>
                                    <span style={{ color: "#006ce0" }}>Remove existing</span>
                                </h3>
                                <FormField
                                    label="Document to remove"
                                >
                                    <Select
                                        selectedOption={selectedUpdateOrDeleteItem}
                                        onChange={({ detail }) =>
                                            setSelectedUpdateOrDeleteItem(detail.selectedOption)
                                        }
                                        options={currentUpdateItem?.content?.links?.map((i, index) => ({...i, 'index': index}))}
                                        placeholder='Select document or tracker to remove'
                                    />
                                </FormField>
                            </>
                        )}

                    </Modal>

                    <Modal
                        onDismiss={() => {
                            setErrorText()
                            setAddResourceModalVisible(false)
                            setFile([])
                            setAddItemTextContent('')
                            setNewResourceTitle()
                            setSelectedResourceTypeToAdd()
                        }}
                        visible={addResourceModalVisible}
                        footer={
                            <>
                                {errorText && (<span style={{ color: "#db0000" }}>{errorText}</span>)}
                                <Box float="right">
                                    <SpaceBetween direction="horizontal" size="xs">
                                        <Button variant="link" onClick={
                                            () => {
                                                setErrorText()
                                                setSelectedResourceTypeToAdd()
                                                setFile([])
                                                setAddItemTextContent('')
                                                setNewResourceTitle()
                                                setAddResourceModalVisible(false)
                                            }
                                        }>Cancel</Button>
                                        
                                        
                                       <Button variant="primary" onClick={addItem}>Add</Button>
                                        
                                    </SpaceBetween>
                                </Box>
                            </>
                        }
                        header="Add resource"
                    >
                        <FormField
                        label="Select resource type"
                        >
                            <Select
                                selectedOption={selectedResourceTypeToAdd}
                                onChange={({ detail }) => {
                                    setSelectedResourceTypeToAdd(detail.selectedOption)
                                }
                                }
                                options={[{label: "Links", value: "KEY-VALUE-LINKS"}, 
                                          {label: "Carousel of Accounting Central Apps", value: "ACCOUNTING-CENTRAL-APPS-CAROUSEL"},
                                          {label: "FGBSBI Quicksight Dashboard", value: "QUICKSIGHT" },
                                          {label: "Amazon-BI Quicksight Dashboard", value: "AMAZON-BI-QS" },
                                          {label: "Wiki Page", value: "WIKI"},
                                          {label: "Amazon Broadcast", value: "BROADCAST"},
                                          {label: "Starmap Calendar", value: "STARMAP"},
                                          {label: "Books Status", value: "BOOKS-STATUS"},
                                          {label: "Amazon News", value: "AMAZON_NEWS"},
                                          {label: "Magnify", value: "MAGNIFY"},
                                          {label: "Allocations", value: "ALLOCATIONS"},
                                          {label: "Report Central", value: "REPORT_CENTRAL"},
                                          {label: "First Pass PRO", value: "FIRST_PASS_PRO"},
                                          {label: "Accounting Central Resource", value: "ACR"},
                                          {label: "Accounting Central App", value: "ACCOUNTING-CENTRAL-APP"},
                                          {label: "Boffin", value: "BOFFIN"},
                                          {label: "TED", value: "TED"},
                                          {label: "SEC Central", value: "SEC_CENTRAL"},
                                          {label: "PDF Document", value: "PDF"},
                                          {label: "Text and Announcements", value: "TEXT"},
                                          {label: "PayStation Central", value: "PAYSTATION_CENTRAL"},
                                          {label: "Pippin", value: "PIPPIN"},
                                          {label: "Pulse Survey", value: "PULSE_SURVEY"},
                                          {label: "Quick Chat Agent", value: "QUICK_CHAT_AGENT"},
                                          {label: "Webpage Resource", value: "WEBPAGE", disabled: !isPortalAdmin, disabledReason: "Only available for Portal Admins"}].sort((a, b) => a.label.localeCompare(b.label))}
                                placeholder='Select resource type to add'
                            />
                        </FormField>

                        <FormField
                            label="Display name"
                        >
                            <Input onChange={({ detail }) => setNewResourceTitle(detail.value)}
                                value={newResourceTitle}
                                placeholder='Display name' 
                            />
                        </FormField>

                        {selectedResourceTypeToAdd?.value === 'TEXT' && (
                            <FormField label="Text Content">
                                <RichTextEditor
                                    value={addItemTextContent}
                                    onChange={setAddItemTextContent}
                                />
                            </FormField>
                        )}

                        {selectedResourceTypeToAdd?.value === 'ACCOUNTING-CENTRAL-APPS-CAROUSEL' && (
                            <>
                            <FormField
                        label="Select apps to add"
                        >
                        
                            <Multiselect
                            selectedOptions={selectedAppsToAdd}
                            onChange={({ detail }) =>
                                setSelectedAppsToAdd(detail.selectedOptions)
                            }
                            options={apps?.map((app) => (
                                { "label": app?.app_name, "value": String(app?.app_id), "customURL": app?.url, "app_description": app?.app_description}
                            ))}
                            placeholder="Select apps to add"
                            virtualScroll
                            filteringType='auto'
                            />
                        </FormField>
                            </>
                        )}
                        
                        {(selectedResourceTypeToAdd?.value === 'QUICKSIGHT' || selectedResourceTypeToAdd?.value === 'AMAZON-BI-QS')  && (
                            <>
                                <FormField
                                    label={selectedResourceTypeToAdd?.value === 'QUICKSIGHT' ? "Dashboard URL" : "Embeddable Dashboard URL"}
                                >
                                    <Input onChange={({ detail }) => setAddItemQSURLInput(detail.value)}
                                        value={addItemQSURLInput}
                                        placeholder={selectedResourceTypeToAdd?.value === 'QUICKSIGHT' ? "Dashboard URL" : "Embeddable Dashboard URL"}
                                    />
                                </FormField>
                                <FormField
                                    label="Description"
                                >
                                    <Textarea
                                        onChange={({ detail }) => setAddItemDescriptionInput(detail.value)}
                                        value={addItemDescriptionInput}
                                        placeholder="Description"
                                    />
                                </FormField>
                            </>
                        )}

                        {selectedResourceTypeToAdd?.value === 'WIKI' && (
                            <FormField
                                label="Wiki URL"
                            >
                                <Input onChange={({ detail }) => setAddItemLinkInput(detail.value)}
                                    value={addItemLinkInput}
                                    placeholder='Provide a valid Wiki URL (https://w.amazon.com/)'
                                />
                            </FormField>
                        )}

                        {selectedResourceTypeToAdd?.value === 'WEBPAGE' && (
                            <FormField
                                label="Webpage URL"
                            >
                                <Input onChange={({ detail }) => setAddItemLinkInput(detail.value)}
                                    value={addItemLinkInput}
                                    placeholder='Provide a valid Embeddable Web URL (starts with, https://)'
                                />
                            </FormField>
                        )}

                        {selectedResourceTypeToAdd?.value === 'BROADCAST' && (
                            <FormField
                                label="Broadcast video URL"
                            >
                                <Input onChange={({ detail }) => setAddItemLinkInput(detail.value)}
                                    value={addItemLinkInput}
                                    placeholder='Provide a valid Broadcast video URL (https://broadcast.amazon.com/videos/<video-id>)'
                                />
                            </FormField>
                        )}

                        {selectedResourceTypeToAdd?.value === 'STARMAP' && (
                            <FormField
                                label="Starmap Calendar URL"
                            >
                                <Input onChange={({ detail }) => setAddItemLinkInput(detail.value)}
                                    value={addItemLinkInput}
                                    placeholder='Provide a valid Starmap Calendar URL (https://starmap.fgbs.amazon.dev/)'
                                />
                            </FormField>
                        )}

                        {URL_RESOURCE_CONFIG[selectedResourceTypeToAdd?.value] && (
                            <>
                            <FormField
                                label={URL_RESOURCE_CONFIG[selectedResourceTypeToAdd.value].label}
                            >
                                <Input onChange={({ detail }) => setAddItemLinkInput(detail.value)}
                                    value={addItemLinkInput}
                                    placeholder={URL_RESOURCE_CONFIG[selectedResourceTypeToAdd.value].placeholder}
                                    disabled={useSpecificUrlDetails}
                                />
                            </FormField>
                            <Checkbox
                                onChange={({ detail }) => {
                                    setUseSpecificUrlDetails(detail.checked);
                                    if (!detail.checked) {
                                        setUrlSegmentInput('');
                                        setAddItemLinkInput('');
                                    } else {
                                        setAddItemLinkInput(URL_RESOURCE_CONFIG[selectedResourceTypeToAdd.value].validationPrefix);
                                        setUrlSegmentInput('');
                                    }
                                }}
                                checked={useSpecificUrlDetails}
                            >
                                Add specific URL details
                            </Checkbox>
                            {useSpecificUrlDetails && (
                                <FormField label="URL Path">
                                    <div className="url-path-container">
                                        <span className="url-path-prefix">
                                            {URL_RESOURCE_CONFIG[selectedResourceTypeToAdd.value].validationPrefix}
                                        </span>
                                        <Input
                                            onChange={({ detail }) => {
                                                setUrlSegmentInput(detail.value);
                                                setAddItemLinkInput(URL_RESOURCE_CONFIG[selectedResourceTypeToAdd.value].validationPrefix + detail.value);
                                            }}
                                            value={urlSegmentInput}
                                            placeholder="Enter path segment"
                                        />
                                    </div>
                                </FormField>
                            )}
                            </>
                        )}

                        {selectedResourceTypeToAdd?.value === 'ACR' && (
                            <FormField
                                label="Accounting Central Resource URL"
                            >
                                <Input onChange={({ detail }) => setAddItemLinkInput(detail.value)}
                                    value={addItemLinkInput}
                                    placeholder='Provide a valid Accounting Central URL'
                                />
                            </FormField>
                        )}

                        {selectedResourceTypeToAdd?.value === 'ACCOUNTING-CENTRAL-APP' && (
                            <FormField
                                label="App"
                            >
                                <Select
                                    selectedOption={selectedACApp}
                                    onChange={({ detail }) =>
                                        setSelectedACApp(detail.selectedOption)
                                    }
                                    options={apps.map((app) => {
                                        return { label: app?.app_name, value: app?.app_id, customURL: app?.url}
                                    })}
                                    placeholder='Select app'
                                    statusType={apps?.length <= 0 ? "loading" : "finished"}
                                    filteringType="auto"
                                    loadingText="Loading apps"
                                    empty="No valid app to recommend for entered text"
                                    virtualScroll={true}
                                    // onLoadItems ={({detail})=>{
                            
                                    // queryApps(detail?.filteringText)
                            
                                    // }}
                                />
                            </FormField>
                        )}

                        {selectedResourceTypeToAdd?.value === 'PDF' && (
                                <FormField
                                    label="PDF Document"
                                >
                                    <FileUpload
                                        onChange={({ detail }) => setFile(detail.value)}
                                        value={file}
                                        i18nStrings={{
                                        uploadButtonText: e =>
                                            e ? "Choose files" : "Choose file",
                                        dropzoneText: e =>
                                            e
                                            ? "Drop files to upload"
                                            : "Drop file to upload",
                                        removeFileAriaLabel: e =>
                                            `Remove file ${e + 1}`,
                                        limitShowFewer: "Show fewer files",
                                        limitShowMore: "Show more files",
                                        errorIconAriaLabel: "Error",
                                        warningIconAriaLabel: "Warning"
                                        }}
                                        showFileLastModified
                                        showFileSize
                                        showFileThumbnail
                                        tokenLimit={3}
                                        accept=".pdf"
                                        constraintText="Please select a PDF file"
                                    />
                                </FormField>
                            )}

                    </Modal>

                    <Modal
                        onDismiss={() => {
                            setErrorText()
                            setCurrentUpdateItem()
                            setSelectedAppsToAdd()
                            setUpdateACAppsCarouselModalVisible(false)
                            
                        }}
                        visible={updateACAppsCarouselModalVisible}
                        footer={
                            <>
                                {errorText && (<span style={{ color: "#db0000" }}>{errorText}</span>)}
                                <Box float="right">
                                    <SpaceBetween direction="horizontal" size="xs">
                                        <Button variant="link" onClick={
                                            () => {
                                                setErrorText()
                                                setCurrentUpdateItem()
                                                setSelectedAppsToAdd()
                                                setUpdateACAppsCarouselModalVisible(false)
                                            }
                                        }>Cancel</Button>
                                        
                                        
                                       <Button variant="primary" onClick={updateAccountingCentralCarousel}>Update</Button>
                                        
                                    </SpaceBetween>
                                </Box>
                            </>
                        }
                        header="Update"
                    >
                            <>
                            <FormField
                        label="Select apps to add"
                        >
                        
                            <Multiselect
                            selectedOptions={selectedAppsToAdd}
                            onChange={({ detail }) =>
                                setSelectedAppsToAdd(detail.selectedOptions)
                            }
                            options={apps?.map((app) => (
                                { "label": app?.app_name, "value": String(app?.app_id), "customURL": app?.url, "app_description": app?.app_description}
                            ))}
                            placeholder="Select apps to add"
                            virtualScroll
                            filteringType='auto'
                            />
                        </FormField>
                            </>
                        
                    </Modal>

                    <Modal
                        onDismiss={() => {
                            setErrorText()
                            setCarouselEditModalVisible(false)
                            setUpdateCarouselItemTitle()
                            setUpdateCarouselItemDescription()
                            setUpdateCurrentCarouselItem()
                        }}
                        visible={carouselEditModalVisible}
                        footer={
                            <>
                                {errorText && (<span style={{ color: "#db0000" }}>{errorText}</span>)}
                                <Box float="right">
                                    <SpaceBetween direction="horizontal" size="xs">
                                        <Button variant="link" onClick={
                                            () => {
                                                setErrorText()
                                                setCarouselEditModalVisible(false)
                                                setUpdateCarouselItemTitle()
                                                setUpdateCarouselItemDescription()
                                                setUpdateCurrentCarouselItem()
                                            }
                                        }>Cancel</Button>
                                        
                                        
                                       <Button variant="primary" onClick={updateCarouselonSave}>Update</Button>
                                        
                                    </SpaceBetween>
                                </Box>
                            </>
                        }
                        header="Edit Dashboard"
                    >
                            <>
                                <h3>
                                    <span style={{ color: "#006ce0" }}>Update Dashboard</span>
                                </h3>
                                <>
                                <FormField
                                    label="Name"
                                    >
                                    <Input onChange={({ detail }) => setUpdateCarouselItemTitle(detail.value)}
                                        value={updateCarouselItemTitle}
                                        placeholder='Name' 
                                        readOnly/>
                                </FormField>

                                <FormField
                                    label="Description"
                                >
                                <Textarea
                                        onChange={({ detail }) => setUpdateCarouselItemDescription(detail.value)}
                                        value={updateCarouselItemDescription}
                                        placeholder="Provide description"
                                />
                                </FormField>
                                </>
                            </>
                    </Modal>

                    <Modal
                        onDismiss={() => setErrorModalVisible(false)}
                        visible={errorModalVisible}
                        footer={
                            <Box float="right">
                            <SpaceBetween direction="horizontal" size="xs">
                                <Button onClick={()=>{setErrorModalVisible(false)}}>Close</Button>
                            </SpaceBetween>
                            </Box>
                        }
                        >
                        Tab of the dashoboard is either hidden or deleted!
                    </Modal>

                    <Modal
                        onDismiss={() => {
                            setTextInputModalVisible(false)
                            setTextInputDraft('')
                            setTextInputTitleDraft('')
                            setTextInputEditItem(null)
                            setErrorText()
                        }}
                        visible={textInputModalVisible}
                        footer={
                            <>
                                {errorText && (<span style={{ color: "#db0000" }}>{errorText}</span>)}
                                <Box float="right">
                                    <SpaceBetween direction="horizontal" size="xs">
                                        <Button variant="link" onClick={() => {
                                            setTextInputModalVisible(false)
                                            setTextInputDraft('')
                                            setTextInputTitleDraft('')
                                            setTextInputEditItem(null)
                                            setErrorText()
                                        }}>Cancel</Button>
                                        <Button variant="primary" onClick={saveTextInput} loading={saveTextInputLoading} disabled={saveTextInputLoading}>Save</Button>
                                    </SpaceBetween>
                                </Box>
                            </>
                        }
                        header="Modify text content"
                    >
                        <SpaceBetween size="m">
                            <FormField label="Display name">
                                <Input
                                    value={textInputTitleDraft}
                                    onChange={({ detail }) => setTextInputTitleDraft(detail.value)}
                                    placeholder="Display name"
                                />
                            </FormField>
                            <FormField label="Content">
                                <RichTextEditor
                                    value={textInputDraft}
                                    onChange={setTextInputDraft}
                                />
                            </FormField>
                        </SpaceBetween>
                    </Modal>


                    <SpaceBetween direction='vertical' size="m">
                        <>
                        {props?.pageType === 'HOME' && (
                            <Autosuggest
                            onFocus={() => {
                                getAllBoardItemsByOwnerTrigger()
                            }}
                            onBlur={() => {
                                setSearchItems([])
                                setSearchValue('')
                            }}
                            onChange={({ detail }) => {
                                setSearchValue(detail.value)}}
                            onSelect={({detail}) => {
                                if(detail?.selectedOption?.board_page_type === 'HOME') {

                                } else if(detail?.selectedOption?.board_item_content_type === 'EXTERNAL-LINK') {
                                    window.open(JSON.parse(detail?.selectedOption?.board_item_content?.replaceAll("'", '"'))?.link, '_blank')
                                } else {
                                    const exists = props?.openResource(detail?.selectedOption?.board_page_type, detail?.selectedOption?.board_item_id)
                                    if(!exists) {
                                        setErrorModalVisible(true)
                                    } else {
                                        history.push(`/ClosePortal/${detail?.selectedOption?.board_page_type?.replaceAll('/', '%2F')}/Page/${selectedOwner?.value}?${detail?.selectedOption?.board_item_id}`)
                                    }
                                }
                                
                            }}
                            value={searchValue}
                            options={searchItems}
                            ariaLabel="Autosuggest example with suggestions"
                            placeholder={`Search ${selectedOwner?.label}`}
                            empty="No matches found"
                            loadingText='loading...'
                            statusType={fetchingSearchItems === true ? 'loading' : 'finished'}
                            enteredTextLabel={(value) => `Searching: ${value}`}
                            virtualScroll
                        />
                        )}
                        </>
                        <Board
                            renderItem={item => (
                                <BoardItem
                                    header={<Header actions={item?.contentType === 'WEBPAGE' ? 
                                        <SpaceBetween direction="horizontal" size="xs">
                                            {item?.rawContent?.url?.startsWith('https://starmap.fgbs.amazon.dev/') &&(<Button
                                                ariaLabel="Create Your Team's Calendar (opens new tab)"
                                                href="https://bi-central.accounting.amazon.dev/ClosePortal/EXECUTIVE/Page/2?resourceId=6a2b2997-98ba-41d5-95db-422c06af0a68"
                                                iconAlign="right"
                                                iconName="external"
                                                target="_blank"
                                            >
                                                Create Your Team's Starmap Calendar
                                            </Button>)}
                                            <Button
                                                ariaLabel="Open Webpage (opens new tab)"
                                                href={item?.rawContent?.url}
                                                iconAlign="right"
                                                iconName="external"
                                                target="_blank"
                                            >
                                                Open Webpage
                                            </Button>
                                        </SpaceBetween> : (item?.contentType === 'TEXT' && addOrEditAccess) ?
                                        <Button iconName="edit" variant="icon" ariaLabel="Edit text content" onClick={() => {
                                            setTextInputEditItem(item)
                                            setTextInputTitleDraft(item?.data?.title || '')
                                            setTextInputDraft(item?.rawContent?.text ? getCleanedItemContent(item.rawContent.text) : '')
                                            setErrorText()
                                            setTextInputModalVisible(true)
                                        }} /> : <></>

                                    }>{item.data.title}</Header>}
                                    i18nStrings={{
                                        dragHandleAriaLabel: "Drag handle",
                                        dragHandleAriaDescription:
                                            "Use Space or Enter to activate drag, arrow keys to move, Space or Enter to submit, or Escape to discard. Be sure to temporarily disable any screen reader navigation feature that may interfere with the functionality of the arrow keys.",
                                        resizeHandleAriaLabel: "Resize handle",
                                        resizeHandleAriaDescription:
                                            "Use Space or Enter to activate resize, arrow keys to move, Space or Enter to submit, or Escape to discard. Be sure to temporarily disable any screen reader navigation feature that may interfere with the functionality of the arrow keys."
                                    }}
                                    settings={ (item?.contentType === 'CAROUSEL' && addOrEditAccess) ?
                                        <ButtonDropdown
                                        items={[
                                            { id: "removeOnCarousel", text: "Remove this dashboard from carousel" },
                                            { id: "editOnCarousel", text: "Edit this dashboard on carousel"}
                                        ]}
                                        ariaLabel="Board item settings"
                                        variant="icon"
                                        onItemClick={(event) => {
                                        if(event?.detail?.id === 'editOnCarousel') {
                                            editItemOnCarousel()
                                        } else if(event?.detail?.id === 'removeOnCarousel') {
                                            removeItemOnCarousel()
                                        }                        
                                        }}
                                        /> : ((item?.contentType !== 'CAROUSEL') && addOrEditAccess) ? 
                                        
                                        <ButtonDropdown
                                        items={[
                                            { id: "deleteItem", text: "Delete for Team" }
                                        ]}
                                        ariaLabel="Board item settings"
                                        variant="icon"
                                        onItemClick={(event) => {
                                        if(event?.detail?.id === 'deleteItem') {
                                            deleteItem(item?.id)
                                        }                      
                                        }}
                                        />:
                                        <></>
                                    }
                                >                                
                                    {item.data.content}
                                    {(item?.contentType === 'KEY-VALUE-LINKS' && addOrEditAccess === true) ?
                                        <Box>
                                            <Button
                                                iconAlign="right"
                                                iconName="edit"
                                                variant="primary"
                                                onClick={() => {
                                                    const updateItem = {}
                                                    updateItem["id"] = item?.id
                                                    updateItem["title"] = item?.data?.title
                                                    updateItem["content"] = item?.rawContent
                                                    setCurrentUpdateItem(updateItem)
                                                    setVisible(true)
                                                }}
                                            >
                                                Modify
                                            </Button>
                                        </Box> 
                                        : <></>}


                                </BoardItem>
                            )}
                            onItemsChange={event => {
                                const updatedItems = event.detail.items
                                updatedItems.forEach((updatedItem) => {
                                    if (updatedItem?.contentType === 'QUICKSIGHT') {
                                        let urlSplit =  updatedItem?.rawContent?.url?.replace(/\/$/, '').split("/")
                                        let foundDashboardsIndex = urlSplit?.findIndex((e)=> e == 'dashboards')
                                        let foundAccountsIndex = urlSplit?.findIndex((e)=> (e == 'account' || e == 'accounts'))
                                        let dashboardId = '';
                                        let region = 'us-east-1';
                                        let account = 'FGBSBI'
                                        if(foundDashboardsIndex !== -1 && urlSplit) {
                                            dashboardId = urlSplit[foundDashboardsIndex + 1] 
                                        }
                                        if(foundAccountsIndex !== -1 && urlSplit) {
                                            let accountId = urlSplit[foundAccountsIndex + 1] 
                                            for (const [key, accountAliases] of Object.entries(quicksightAccountMapper)) {
                                            let found = accountAliases.findIndex((e)=> e.toUpperCase() === accountId.toUpperCase())
                                            if(found !== -1) {
                                                account = key
                                                break;
                                            }
                                            }
                                        }  
                                        if(urlSplit && urlSplit[2].includes("quicksight")){
                                        region = urlSplit[2].split(".")[0]
                                        }
                                        if(account && region && dashboardId) {
                                        const result = getQSDashboardEmbedLinksSync(account, region, dashboardId).then((url) => {
                                            const content = (<>
                                                <iframe
                                                    className="cp_embedment"
                                                    src={url?.url}>
                                                </iframe>
                                            </>)
                                            updatedItem["data"]["content"] = content
                                        })
                                    } else {
                                        const content = (<><span style={{ color: "#db0000" }}>A Valid Quicksight dashboard URL not found!</span></>)
                                            updatedItem["data"]["content"] = content
                                    }
                                    }
                                })
                                setItems(updatedItems)

                            }
                            }
                            items={items}
                            i18nStrings={(() => {
                                function createAnnouncement(
                                    operationAnnouncement,
                                    conflicts,
                                    disturbed
                                ) {
                                    const conflictsAnnouncement =
                                        conflicts.length > 0
                                            ? `Conflicts with ${conflicts
                                                .map(c => c.data.title)
                                                .join(", ")}.`
                                            : "";
                                    const disturbedAnnouncement =
                                        disturbed.length > 0
                                            ? `Disturbed ${disturbed.length} items.`
                                            : "";
                                    return [
                                        operationAnnouncement,
                                        conflictsAnnouncement,
                                        disturbedAnnouncement
                                    ]
                                        .filter(Boolean)
                                        .join(" ");
                                }
                                return {
                                    liveAnnouncementDndStarted: operationType =>
                                        operationType === "resize"
                                            ? "Resizing"
                                            : "Dragging",
                                    liveAnnouncementDndItemReordered: operation => {
                                        const columns = `column ${operation.placement
                                            .x + 1}`;
                                        const rows = `row ${operation.placement.y +
                                            1}`;
                                        return createAnnouncement(
                                            `Item moved to ${operation.direction === "horizontal"
                                                ? columns
                                                : rows
                                            }.`,
                                            operation.conflicts,
                                            operation.disturbed
                                        );
                                    },
                                    liveAnnouncementDndItemResized: operation => {
                                        const columnsConstraint = operation.isMinimalColumnsReached
                                            ? " (minimal)"
                                            : "";
                                        const rowsConstraint = operation.isMinimalRowsReached
                                            ? " (minimal)"
                                            : "";
                                        const sizeAnnouncement =
                                            operation.direction === "horizontal"
                                                ? `columns ${operation.placement.width}${columnsConstraint}`
                                                : `rows ${operation.placement.height}${rowsConstraint}`;
                                        return createAnnouncement(
                                            `Item resized to ${sizeAnnouncement}.`,
                                            operation.conflicts,
                                            operation.disturbed
                                        );
                                    },
                                    liveAnnouncementDndItemInserted: operation => {
                                        const columns = `column ${operation.placement
                                            .x + 1}`;
                                        const rows = `row ${operation.placement.y +
                                            1}`;
                                        return createAnnouncement(
                                            `Item inserted to ${columns}, ${rows}.`,
                                            operation.conflicts,
                                            operation.disturbed
                                        );
                                    },
                                    liveAnnouncementDndCommitted: operationType =>
                                        `${operationType} committed`,
                                    liveAnnouncementDndDiscarded: operationType =>
                                        `${operationType} discarded`,
                                    liveAnnouncementItemRemoved: op =>
                                        createAnnouncement(
                                            `Removed item ${op.item.data.title}.`,
                                            [],
                                            op.disturbed
                                        ),
                                    navigationAriaLabel: "Board navigation",
                                    navigationAriaDescription:
                                        "Click on non-empty item to move focus over",
                                    navigationItemAriaLabel: item =>
                                        item ? item.data.title : "Empty"
                                };
                            })()}
                            empty={
                                <Box
                                    margin={{ vertical: "xs" }}
                                    textAlign="center"
                                    color="inherit"
                                >
                                    <SpaceBetween size="m">
                                        <Box variant="strong" color="inherit">
                                            No items
                                        </Box>
                                    </SpaceBetween>
                                </Box>
                            }
                        />
                        {addOrEditAccess && (<Box float='right'><SpaceBetween direction="horizontal" size="m"><Button onClick={()=>{setAddResourceModalVisible(true); queryApps()}} iconName="add-plus">Add resource</Button><Button variant="primary" onClick={saveLayout} loading={saveLayoutLoading}>Save layout</Button></SpaceBetween></Box>) }
                    </SpaceBetween>
                </Box>
            }
        </>
    );
}

export default CPBoardView;
